<template>
  <el-dialog
    title="编辑费用项目"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    destroy-on-close
    :close-on-click-modal="false"
  >

    <el-form :model="editForm" :rules="rules" ref="editForm" label-width="180px" size="small">
      <el-form-item label="收费项：" prop="price_name">
        <el-input v-model="editForm.price_name" placeholder="请输入收费项"></el-input>
      </el-form-item>
      <el-form-item label="交付批次：" prop="delivery_name">
        <el-input v-model="editForm.delivery_name" placeholder="请输入交付批次"></el-input>
      </el-form-item>
      <el-form-item label="数量：" prop="item_count">
        <el-input v-model="editForm.item_count" type="number" min="1" placeholder="请输入数量"></el-input>
      </el-form-item>
      <el-form-item label="单价（元）：" prop="unit_price">
        <el-input v-model="editForm.unit_price" type="number" step="0.01" placeholder="请输入单价"></el-input>
      </el-form-item>
      
      <el-form-item label="单位：" prop="metering_unit">
        <el-select v-model="editForm.metering_unit" placeholder="请选择单位" style="width: 100%;">
          <el-option label="台·日" value="1"></el-option>
          <el-option label="卡·时" value="2"></el-option>
          <el-option label="T·月" value="3"></el-option>
          <el-option label="台·月" value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="金额（元）：" prop="total_amount">
        <el-input v-model="editForm.total_amount" type="number" step="0.01" placeholder="请输入金额"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input v-model="editForm.remark" type="textarea"
          :rows="3"
          placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditBill',
  data() {
    return {
      dialogVisible: false,
      itemId: null,
      editForm: {
        bill_id: '',
        price_name: '',
        delivery_name: '',
        item_count: 1,
        metering_unit: 1,
        unit_price: '',
        total_amount: '',
        remark: ''
      },
      rules: {
        price_name: [
          { required: true, message: '请输入收费项', trigger: 'blur' }
        ],
        metering_unit: [{ required: true, message: '请选择单位', trigger: 'change' }],
        unit_price: [
          { required: true, message: '请输入单价', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              const num = Number(value);
              if (isNaN(num) || num < 0) {
                callback(new Error('单价必须为非负数'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        item_count: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const num = Number(value);
              if (isNaN(num) || num < 1) {
                callback(new Error('数量必须大于等于1'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        
        total_amount: [
          { required: true, message: '金额不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const str = String(value).trim();

              // 再次检查空值
              if (!str) {
                return callback(new Error('金额不能为空'));
              }

              // 支持负数、正数、零，最多两位小数
              // 例如：123, -123.45, 0.01, -0.01, 0.1, .5（可选支持）等
              const moneyPattern = /^-?(0|[1-9]\d*)(\.\d{1,2})?$/;

              if (!moneyPattern.test(str)) {
                return callback(new Error('请输入有效金额，最多保留两位小数（可为负数）'));
              }

              callback();
            },
            trigger: 'blur'
          }
        ],
       
      }
    };
  },
  methods: {
    openDialog(id) {
      console.log('EditBill: openDialog with id=', id);

      this.itemId = id;
      this.fetchDetail(id);
    },
    fetchDetail(id) {
      this.$axios.get(`/api-30216/api/bill-other-items/${id}`)
        .then(res => {
          if (res.code === 200 && res.data) {
            const data = res.data;
            this.editForm = {
              price_name: data.price_name || '',
              bill_id: data.bill_id || '',
              delivery_name: data.delivery_name || '',
              metering_unit: data.metering_unit || 1,
              unit_price: data.unit_price || '',
              item_count: data.item_count || 1,
              total_amount: data.total_amount || '',
              remark: data.remark || ''
            };
            this.dialogVisible = true; // ✅ 打开弹窗
          } else {
            this.$message.error(res.message || '获取详情失败');
          }
        })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error('获取详情失败:', err);
        });
    },
    submitForm() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;
        this.$axios.put(`/api-30216/api/bill-other-items/${this.itemId}`, this.editForm)
          .then(res => {
            if (res.code === 200) {
              this.$message.success('更新成功');
              this.dialogVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(res.message || '更新失败');
            }
          })
          .catch(err => {
            this.$message.error('提交失败');
            console.error(err);
          });
      });
    },
    resetForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.itemId = null;
    }
  }
};
</script>